var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bell_svg__clip0_516_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.512 21a2.727 2.727 0 01-1.827-.711 2.782 2.782 0 01-.892-1.761h5.474a2.83 2.83 0 01-.917 1.76A2.774 2.774 0 019.512 21zm9.5-5.544a1.54 1.54 0 01-.442 1.102 1.507 1.507 0 01-1.09.446H1.532c-.406 0-.796-.163-1.083-.453a1.556 1.556 0 010-2.19c.287-.29.677-.453 1.083-.453a1.787 1.787 0 001.308-.53 1.825 1.825 0 00.533-1.318V7.728v-.312a6.195 6.195 0 011.39-3.88 6.08 6.08 0 013.502-2.12v-.18c0-.328.129-.642.358-.874a1.217 1.217 0 011.73 0c.23.232.358.546.358.874v.132a6.092 6.092 0 013.5 2.123 6.207 6.207 0 011.393 3.877 1.38 1.38 0 010 .312v4.332a1.841 1.841 0 00.532 1.318 1.803 1.803 0 001.308.53 1.506 1.506 0 011.12.458A1.536 1.536 0 0119 15.456h.012z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bell_svg__clip0_516_1237"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h19v21H0z"
  })))));
}
export default SvgBell;